class StaffEditController {
  constructor(
    TrainingCentersFactory,
    $rootScope,
    $state,
    $stateParams,
    ngDialog
  ) {
    "ngInject";
    const vm = this;

    vm.trainingCenterId = $stateParams.id;
    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.trainingCenter = {
        id: $stateParams.id,
      };
      if (vm.trainingCenter.id) {
        TrainingCentersFactory.getOne(vm.trainingCenter.id).then((response) => {
          vm.trainingCenter = response.data;
        });
      }
    };

    vm.submit = () => {
      if (vm.trainingCenter.id) {
        TrainingCentersFactory.update(
          vm.trainingCenter.id,
          vm.trainingCenter
        ).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.reload();
        });
      } else {
        TrainingCentersFactory.create(vm.trainingCenter).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          $state.go("trainingCenter-edit", { id: response.data.id });
        });
      }
    };

    vm.goToProfile = () => {
      $state.go("trainingCenter-profile", { id: vm.trainingCenter.id });
    };
  }
}

export default StaffEditController;



// WEBPACK FOOTER //
// ./client/app/components/trainingCenters/trainingCenterEdit/trainingCenterEdit.controller.js